/*
 * ////////////////////////////////////////////////////////////////////////////////
 * //
 * // This software system consists of computer software and documentation.
 * // It contains trade secrets and confidential information which are proprietary
 * // to Everi Games Inc.  Its use or disclosure in whole or in part without
 * // the express written permission of Everi Games Inc. is prohibited.
 * //
 * // This software system is also an unpublished work protected under the copyright
 * // laws of the United States of America.
 * //
 * // Copyright © 2018 Everi Games Inc.  All Rights Reserved
 * //
 * ////////////////////////////////////////////////////////////////////////////////
 */
import MutatorComponentBase from "./MutatorComponentBase";

/** @hidden */
// tslint:disable-next-line:typedef
const property = cc._decorator.property;

@cc._decorator.ccclass
export default class FontMutator extends MutatorComponentBase
{
    @property()
    public get UpdateLabels(): boolean { return false; }
    public set UpdateLabels(value: boolean)
    {
        this.execute(this.rootNode, [this.labelHandler.bind(this)]);
    }

    @property({ type: cc.Node })
    protected rootNode: cc.Node = null;

    @property({ type: cc.Label })
    public get Import(): cc.Label { return null; }
    public set Import(value: cc.Label) { this.importFromLabel(value); }

    @property(cc.Font)
    protected font: cc.Font = null;

    @property(cc.Float)
    protected originalFontSize: number = 0;

    @property(cc.Float)
    protected updatedFontSize: number = 20;

    @property(cc.Float)
    protected updatedLineHeight: number = 20;

    @property(cc.Float)
    protected updatedSpacingX: number = 0;

    private labelHandler(target: cc.Node): boolean
    {
        if (!this.font) { return; }

        let label: cc.Label = target.getComponent(cc.Label);

        if (!label || !label.font || label.isSystemFontUsed || label.font.name !== this.font.name) { return false; }

        // tslint:disable-next-line:max-line-length
        this.warn(label.node, `Found label font-size: [${label.fontSize}], line-height: [${label.lineHeight}].`);

        if (this.shouldModify)
        {
            if (label.fontSize !== this.originalFontSize)
            {
                this.warn(label.node, `Font size does not match original.`);
                return false;
            }
            label.fontSize = this.updatedFontSize;
            label.lineHeight = this.updatedLineHeight;
            // tslint:disable-next-line:no-string-literal
            label['spacingX'] = this.updatedSpacingX;

            // tslint:disable-next-line:max-line-length
            this.warn(label.node, `Set font-size: [${label.fontSize}], line-height: [${label.lineHeight}], spacing-x: [${this.updatedSpacingX}].`);
        }
    }

    private importFromLabel(label: cc.Label): void
    {
        this.font = label.font;
        this.originalFontSize = label.fontSize;
        // tslint:disable-next-line:no-string-literal
        this.updatedSpacingX = label['spacingX'];
    }
}
